import React from 'react'
import styled from 'styled-components';

const StyledLoadingSpinner = styled.div`


@-webkit-keyframes rotate {
  0% {
    transform: rotate(-360deg);
  }
}
@keyframes rotate {
  0% {
    transform: rotate(-360deg);
  }
}
@-webkit-keyframes wink {
  50% {
    opacity: 0;
  }
}
@keyframes wink {
  50% {
    opacity: 0;
  }
}
.spinner {
  width: 7em;
  margin: 3em auto;
  position: relative;
}
.spinner:before {
  content: "";
  display: block;
  width: 7em;
  height: 1em;
  margin: 3em auto;
  padding: 3em 0;
  border-radius: 50%;
  border: 2px solid #8C683C;
  border-top: 2px solid transparent;
  border-bottom: 2px solid transparent;
  -webkit-animation: rotate 1s ease infinite;
          animation: rotate 1s ease infinite;
}
.spinner:after {
  content: "Loading";
  position: absolute;
  top: 0;
  color: #8C683C;
  font: 0.9em sans-serif;
  width: 8em;
  line-height: 8em;
  text-align: center;
  -webkit-animation: wink 1.4s ease infinite;
          animation: wink 1.4s ease infinite;
}
`;
const LoadingSpinner = () => {
  return (
    <StyledLoadingSpinner>
<div className="spinner"></div>
    </StyledLoadingSpinner>
  )
}

export default LoadingSpinner